module.exports = __webpack_public_path__ + "img/correspondent-logo.a41ec045.png";